<!-- Searchable Select with autocomplete (styled like DynamicForm) -->
<div
  class="flex flex-col"
  (focus)="onSearchableSelectFocusIn(field)"
  tabindex="0"
>
  <div class="relative w-full">
    <input
      type="text"
      [(ngModel)]="field.searchTerm"
      (blur)="closeListWithDelay(field)"
      (focus)="field.listOpen = true; 
                field.searchTerm = '';
                field.onSearchTermChange?.({ target: { value: field.searchTerm } });
                field.onChange!(0);
                "
      (mousedown)="field.listOpen = true"
      (input)="onSearchableSelectInput(field)"
      [attr.placeholder]="(isDataLoading ? 'Loading...' : 'Search...') | transloco"
      class="shadow-sm bg-gray-50 border-input border-blue-100 text-gray-900 text-base rounded-input block w-full p-2 pr-10 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
      [attr.autocomplete]="'off'"
      [id]="field.name"
      (keydown)="onSearchableSelectKeydown($event, field)"
      [ngClass]="{
        'bg-gray-200 text-gray-400 cursor-not-allowed':
          field.disabled,
        'bg-gray-50 text-gray-900': !field.disabled && !field.loading && !isDataLoading
      }"
      [disabled]="field.disabled ?? false"
    />
    <!-- Spinner shown when field.loading is true -->
    <div *ngIf="field.loading" class="absolute right-8 top-2 flex items-center">
      <app-spinner class="h-3 w-3" />
    </div>
    <button
      type="button"
      class="absolute right-2 top-2 flex items-center"
      [attr.aria-label]="'Clear selection' | transloco"
      [disabled]="field.disabled ?? false"
      (click)="
                            field.searchTerm = '';
                            field.onSearchTermChange?.({ target: { value: field.searchTerm } });
                            field.onChange!(0);
                            onSearchableSelectFocusIn(field);
                         "
    >
      <ng-icon
        *ngIf="!field.loading"
        name="matClose"
        aria-hidden="true"
        class="text-2xl text-blue-400"
      />
    </button>
  </div>
  <div class="relative">
    <ul
      *ngIf="field.listOpen"
      (mousedown)="$event.preventDefault()"
      class="absolute z-10 w-full bg-white dark:bg-gray-700 border border-blue-100 rounded shadow-lg max-h-60 overflow-y-auto"
    >
      <li
        [id]="field.name + '-option-' + index"
        *ngFor="let option of field.options; let index = index"
        (mousedown)="
          field.searchTerm = option.searchTerm;
          field.onChange!(option.value);
          field.listOpen = false
        "
        class="px-4 py-2 cursor-pointer hover:bg-blue-100 dark:hover:bg-blue-800"
      >
        {{ option.translate === false ? option.label : (option.label | transloco) }}
      </li>
    </ul>
  </div>
</div>
